import { PracticeFeatures } from "app/models/practice"
import { FeatureFlagTypes, ISupportSettingsFeaturesData } from "./types"

export const mapFormValuesToPayload = (features: ISupportSettingsFeaturesData["features"]) =>
  Object.values(FeatureFlagTypes).reduce(
    (currentFeatures, feature) => ({
      ...currentFeatures,
      [feature]: features.includes(feature),
    }),
    {} as PracticeFeatures,
  )
